// @flow
import React from 'react';
import * as R from 'ramda';

import type {
  Issue,
} from 'chronos-types';

import {
  stj,
} from 'chronos-utils';

import {
  AkFieldRadioGroup as RadioButtonGroup,
} from '@atlaskit/field-radio-group';
import TextField from '@atlaskit/field-text';
import {
  Flex,
} from 'chronos-styled';

import {
  InputExample,
} from './styled';

type Props = {
  issue: Issue,
  value: 'auto' | 'new' | 'leave' | 'manual',
  onChange: Function,
  onReduceByChange: Function,
  onNewChange: Function,
  newValue: string,
  reduceByValue: string,
  showReduceBy: boolean,
};

const RemainingEstimatePicker = ({
  issue,
  value,
  onChange,
  onReduceByChange,
  onNewChange,
  newValue,
  reduceByValue,
  showReduceBy,
}: Props) => {
  const timeestimate = R.path(['fields', 'timeestimate'], issue);

  const remainingEstimateOptions = [
    {
      name: 'auto',
      value: 'auto',
      label: (
        <Flex
          column
          justify="center"
          width="100%"
          padding="20px 0 0 0"
          style={{
            whiteSpace: 'nowrap',
          }}
        >
          <span>
            Adjust automatically
          </span>
          <span
            style={{
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '20px',
              color: '#6c798f',
            }}
          >
            the estimate will be reduced by the amount of work done, but never below 0.
          </span>
        </Flex>
      ),
      isSelected: value === 'auto',
    },
    {
      name: 'leave',
      value: 'leave',
      label: `Use existing estimate of ${stj((timeestimate || 0))}`,
      isSelected: value === 'leave',
    },
    {
      name: 'new',
      value: 'new',
      label: (
        <Flex
          align="center"
          width="100%"
          spacing={8}
          style={{
            whiteSpace: 'nowrap',
          }}
        >
          <span>
            Set to
          </span>
          <TextField
            value={newValue}
            isCompact
            onChange={e => onNewChange(e.target.value)}
            isLabelHidden
            isDisabled={value !== 'new'}
          />
          <InputExample>
            (eg. 2h 10m)
          </InputExample>
        </Flex>
      ),
      isSelected: value === 'new',
    },
    ...(
      showReduceBy
        ? [{
          name: 'manual',
          value: 'manual',
          label: (
            <Flex
              align="center"
              width="100%"
              spacing={8}
              style={{
                whiteSpace: 'nowrap',
                marginTop: '5px',
              }}
            >
              <span>
                Reduce by
              </span>
              <TextField
                value={reduceByValue}
                onChange={e => onReduceByChange(e.target.value)}
                isLabelHidden
                isDisabled={value !== 'manual'}
              />
              <InputExample>
                (eg. 40m)
              </InputExample>
            </Flex>
          ),
          isSelected: value === 'manual',
        }] : []
    ),
  ];

  return (
    <Flex column width="100%">
      <RadioButtonGroup
        label="Remaining Estimate"
        items={remainingEstimateOptions}
        onRadioChange={e => onChange(e.target.value)}
      />
    </Flex>
  );
};

export default RemainingEstimatePicker;
